var _path, _path2, _rect;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMinimizeIcon = function SvgMinimizeIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1025 11.6798H14.1956V11.5866V10.5946V10.5014H14.1025H11.9634L16.4359 6.1688L16.5033 6.10345L16.4374 6.03651L15.7334 5.32111L15.6686 5.25522L15.6022 5.31955L11.1731 9.61047V7.45317V7.35999H11.0799H10.0347H9.94149V7.45317V11.5866V11.6798H10.0347H14.1025Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.186364
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93311 10.6327V3.47876H18.2486V17.7867H11.2082",
    stroke: "currentColor",
    strokeWidth: 1.56545
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.46362,
    y: 12.5405,
    width: 5.63232,
    height: 5.72317,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMinimizeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/minimize_icon.55d0445f.svg";
export { ForwardRef as ReactComponent };